export const normalizeInteger = value => {
	return value.replace(/[^\d]/g, '');
};
